import request from "@/utils/request";

// 获取地区列表
export function getAreaTree(data) {
  return request({
    method: "post",
    path: "common/getAreaTree",
    data,
  });
}

// 获取地区列表
export function getAreaList(data) {
  return request({
    method: "post",
    path: "common/getAreaList",
    data,
  });
}

// 获取底部菜单
export function getNavbar(data) {
  return request({
    method: "post",
    path: "common/navbar",
    data,
  });
}

// 发送短信
export function sendCode(data) {
  return request({
    method: "post",
    path: "common/sendCode",
    data,
  });
}

// 上传图片
export function uploadImage(data) {
  return request({
    method: "post",
    path: "common/uploadImage",
    data,
  });
}

// 上传文件
export function uploadFile(data) {
  return request({
    method: "post",
    path: "common/uploadFile",
    data,
  });
}

// 获取系统配置
export function getSystemConfig(data) {
  return request({
    method: "post",
    path: "common/getSystemConfig",
    data,
  });
}

// 获取办事处列表
export function getAllOfficeList(data) {
  return request({
    method: "post",
    path: "common/getAllOfficeList",
    data,
  });
}

// 获取配置
export function getConfig(data) {
  return request({
    method: "post",
    path: "common/getConfig",
    data,
  });
}

// 快速订购预览
export function importPreview(data) {
  return request({
    method: "post",
    path: "common/importPreview",
    data,
  });
}
// 获取系统配置
export function getSiteInfo(data) {
  return request({
    method: "post",
    path: "common/getSiteInfo",
    data,
  });
}
